import { apiClient } from 'core/api/globals';

import { AuthenticationManager } from './services/AuthenticationManager';

export const globalAuthenticationManager = new AuthenticationManager(apiClient);
